import { HexGridType } from 'js/bubbleCore/types';

export function isPointyTop(type: HexGridType): boolean {
  return type === HexGridType.EvenR || type === HexGridType.OddR;
}